import StateType from './state.type';

export default {
  loading: false,
  loadingSave: false,
  invoiceConfiguration: {},
  preSignedUrlCertificate: null,
  preSignedUrlLogo: null,
} as StateType;
